export default "__VITE_ASSET__18abc0eb__"